"use client"

import { useId, useMemo } from "react"
import { useManagedDialog } from "./use-managed-dialog.ts"

const splitMessage = (message: string): { readonly detail: string; readonly summary: string } => {
  const trimmed = message.trim()
  const boundary = trimmed.search(/[.!?](?:\s|$)/)
  if (boundary < 0 || boundary === trimmed.length - 1) return { detail: "", summary: trimmed }
  return {
    detail: trimmed.slice(boundary + 1).trim(),
    summary: trimmed.slice(0, boundary + 1).trim(),
  }
}

export const ActionFeedbackSheet = ({ message, onClose, title = "확인이 필요해요" }: { readonly message: string; readonly onClose: () => void; readonly title?: string }) => {
  const headingId = useId()
  const copy = useMemo(() => splitMessage(message), [message])
  const open = message.trim().length > 0
  const { cancel, dialogRef, onDialogClose } = useManagedDialog(open, onClose)

  return (
    <dialog
      aria-describedby={`${headingId}-message`}
      aria-labelledby={headingId}
      className="action-feedback-dialog"
      data-action-feedback-sheet
      onCancel={(event) => {
        event.preventDefault()
        cancel()
      }}
      onClose={onDialogClose}
      ref={dialogRef}
    >
      <div className="action-feedback-content">
        <header className="action-feedback-heading">
          <div>
            <span className="eyebrow">CashHub 안내</span>
            <h2 id={headingId}>{title}</h2>
          </div>
          <button aria-label="안내 닫기" className="action-feedback-close" onClick={cancel} type="button">
            ×
          </button>
        </header>
        <div className="action-feedback-message" id={`${headingId}-message`}>
          <strong>{copy.summary}</strong>
          {copy.detail.length === 0 ? null : <p>{copy.detail}</p>}
        </div>
      </div>
    </dialog>
  )
}
